import{__awaiter as r}from"../../../../../node_modules/tslib/tslib.es6.js";import{shopifyStorefrontClientWrapper as i}from"../../../../../lib/clients.js";import{handleError as o}from"../../../../../lib/error-handler.js";import{gql as e}from"graphql-request";import{shopifyMediaToUnlikelyMedia as d}from"../utils/serializer.js";import{STOREFRONT_MEDIA_FRAGMENT as l}from"../../fragments/media.js";const s=e`
  query getMediaById($id: ID!) {
    node(id: $id) {
      ${l}
    }
  }
`,t=i(((i,e)=>r(void 0,void 0,void 0,(function*(){const{id:r}=null!=e?e:{},l={id:r},t=yield i.request(s,l);return{errors:o(null==t?void 0:t.errors),media:(null==t?void 0:t.node)?d(t.node):null}}))));export{t as sfMedia};
//# sourceMappingURL=media.js.map
